import React from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Empty, Form, Input } from 'antd';
import getName from '../../../../../../helpers/getName';
import ChoiceDateField from '../../../formComponents/ChoiceDateField';
import MeterReadingFields from './MeterReadingFields';
import { facilityMetersKeys } from '../../../../queries/queryKeys';
import styles from '../RemoveTenantFromRoomModal.module.scss';

const RemoveTenantFromRoomForm = ({ form, initialValues }) => {
  const { getFieldDecorator } = form;

  const { facilityId, roomId } = useParams();

  const queryClient = useQueryClient();

  const meters = queryClient.getQueryData(
    facilityMetersKeys({ facilityId, officeId: roomId })
  );

  const choiceDateValidator = (_rule, value, callback) => {
    if (value) {
      const { accountStartDate } = initialValues;

      const endDate = value.clone().utc().format();

      const startAfterEnd = moment(accountStartDate).isAfter(endDate, 'day');
      const startSameEnd = moment(accountStartDate).isSame(endDate, 'day');

      if (startAfterEnd) {
        callback(
          'Дата завершения не может быть раньше начала предоставления услуг'
        );
      } else if (startSameEnd) {
        callback(
          'Дата завершения не может совпадать с началом предоставления услуг'
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  return (
    <Form>
      <div className={styles.formRow}>
        <Form.Item label="Арендатор" className={styles.formItem}>
          <Input
            defaultValue={initialValues?.name || getName(initialValues || {})}
            disabled
          />
        </Form.Item>
        <Form.Item label="Лицевой счет" className={styles.formItem}>
          <Input defaultValue={initialValues?.account || '-'} disabled />
        </Form.Item>
      </div>
      <div className={styles.formRow}>
        <Form.Item
          label="Начало предоставления услуг"
          className={styles.formItem}
        >
          <Input
            defaultValue={
              initialValues?.accountStartDate &&
              moment(initialValues.accountStartDate).format('DD.MM.YYYY')
            }
            disabled
          />
        </Form.Item>
        <ChoiceDateField
          className={styles.formItem}
          label="Конец предоставления услуг"
          name="endDate"
          getFieldDecorator={getFieldDecorator}
          validationRules={[{ validator: choiceDateValidator }]}
          datePickerProps={{
            disabledDate: (currentDate) => currentDate.isAfter(moment(), 'day'),
          }}
        />
      </div>
      <Form.Item required label="Срез счетчиков на последний день аренды" />
      {Boolean(meters?.length) ? (
        <MeterReadingFields
          meters={meters}
          getFieldDecorator={getFieldDecorator}
        />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="У помещения нет счетчиков"
        />
      )}
    </Form>
  );
};

export default RemoveTenantFromRoomForm;
